import { Loader } from "../components";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { CloudDownloadOutlined } from "@ant-design/icons";
import MonthlyReportTable from "../components/MonthlyReportTable";
import generatePDF from "./generatePDF"; // Import the new PDF generation function
import { fetchingEmployeeStart, fetchingEmployeeSuccess } from "../redux/attendanceSlice";
import { reduxFromDate, reduxToDate } from "../redux/setDates";
import { postRequest } from "../utils/APICall";

const MonthlyEmployeeReport = ({ name }) => {
    const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const { singleEmployeeAttendance, isFetching } = useSelector(
    (state) => state.employeeAtt
  );
  const { toDate, fromDate } = useSelector((state) => state.setDates);

  const handleDownload = async () => {
  await generatePDF(singleEmployeeAttendance, name, fromDate, toDate);
};

useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchingEmployeeStart());
  
      const fromDate = searchParams.get("fromDate");
      const toDate = searchParams.get("toDate");
      const department = searchParams.get("department");
      const empid = searchParams.get("employee");
      dispatch(reduxToDate(toDate));
      dispatch(reduxFromDate(fromDate))
      let route;
      let obj;
  
      if (empid && empid !== "All") {
        // Single employee
        route = "getByEmpId";
        obj = {empid : Number(empid), todate: toDate, fromdate: fromDate };
      } else if (department === "All") {
        // All employees, all departments
        route = "getAllEmployeesAttendance";
        obj = { todate: toDate, fromdate: fromDate };
      } else {
        // All employees in specific department
        route = `getAllEmployeesAttendance?departmentcode=${department}`;
        obj = { todate: toDate, fromdate: fromDate };
      }
      // console.log("data-->>>>>>",obj, route)
      try {
        const response = await postRequest(route, obj);
        // console.log("Response",response)
        if(Object.keys(response).length > 0){
          dispatch(fetchingEmployeeSuccess(response));
        }
      } catch (err) {
        console.error("Error fetching report:", err);
      }
    };
  
    fetchData();
  }, [searchParams, dispatch]);
  // console.log(singleEmployeeAttendance)

  return (
    <div className="-z-10">
      <div className="h-full">
        <div className="flex w-full items-center">
          <h1 className="flex w-full justify-center text-lg items-center sm:text-xl lg:text-2xl font-bold text-start md:py-2 md:pl-12 md:mb-0">
            Monthly Employee Report
          </h1>
          <button className="flex justify-around items-center mr-5">
            <CloudDownloadOutlined
              onClick={handleDownload}
              className="text-[26px] md:-mt-0 text-center md:text-[30px]"
            />
          </button>
        </div>
        <div className="mb-2 w-full flex justify-center items-center">
          <div className="flex w-16 justify-around items-center text-sm">
            <span className="h-4 w-4 bg-red-300"></span>
            <span>Absent</span>
          </div>
          <div className="flex w-12 justify-around items-center text-sm">
            <span className="h-4 w-4 bg-yellow-200"></span>
            <span>Late</span>
          </div>
          <div className="flex w-16 justify-around items-center text-sm">
            <span className="h-4 w-4 bg-green-200"></span>
            <span>Holiday</span>
          </div>
          <div className="flex w-16 justify-around items-center px-1 text-sm">
            <span className="h-4 w-4 bg-purple-400"></span>
            <span>Leave</span>
          </div>
        </div>
      </div>
      {isFetching ? (
        <Loader />
      ) : (
        <MonthlyReportTable employeeAttendance={singleEmployeeAttendance} />
      )}
    </div>
  );
};

export default MonthlyEmployeeReport;
